export const TenantTypes = {
    customer_production: 'customer_production',
    partner_production: 'partner_production',
    /** https://jira.sage.com/browse/SIT-1446 */
    SIAP_production: 'SIAP_production',
    /** https://jira.sage.com/browse/SIT-1446 */
    MEDC_production: 'MEDC_production',
    sandbox: 'sandbox',
    developer: 'developer',
    sales_demo: 'sales_demo',
    implementation: 'implementation',
    debug: 'debug',
    test: 'test',
    preview: 'preview',
    other: 'other',
};
export const PRODUCTION_TENANT_TYPES = [
    TenantTypes.customer_production,
    TenantTypes.partner_production,
    TenantTypes.MEDC_production,
    TenantTypes.SIAP_production,
];
/**
 * Automatic Intacct sync only runs for production tenants that have not opted
 * out. This is derived, never stored, so every caller must use this helper.
 */
export function isAutomaticSyncEnabled(shouldSyncAutomatically, tenantType) {
    return (shouldSyncAutomatically &&
        !!tenantType &&
        PRODUCTION_TENANT_TYPES.includes(tenantType));
}
//# sourceMappingURL=tenant-type.js.map